import { useMemo } from 'react';
import IconLoader from '../../icons/loader';
import { Currency, GeneralLedgerTransaction } from '../types';
import Table from '../../table/table';
import { columns } from './variables/list';
import formatDate from '../../../helpers/format-date';
import formatBalance from '../../../helpers/format-balance';
import { AccountingEntriesTypes } from './types';

import styles from './accounting-entries.module.css';

const formatGLList = ({
  list,
  currenciesList,
}: {
  list: GeneralLedgerTransaction[];
  currenciesList?: Currency[];
}): GeneralLedgerTransaction[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };
    const currencyItem = currenciesList?.find(
      (currency) => currency.id === result?.currency.id,
    );

    const render: Record<string, React.JSX.Element> = {
      transferDate: <div>{formatDate(result?.transferDate || '', true)}</div>,
      currencyId: <div>{result?.currency.name || ''}</div>,
      debitAccountId: <div>{result?.debitAccount?.fullNumber || ''}</div>,
      creditAccountId: <div>{result?.creditAccount?.fullNumber || ''}</div>,
      sum: <div>{formatBalance(result.sum, currencyItem)}</div>,
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default function AccountingEntries({
  glTransactionsIsLoading,
  glTransactions,
  setGlTransactionSidePanelVisible,
  onGlTransactionClick,
  setTransactionSidepanelVisible,
  currenciesList,
}: AccountingEntriesTypes) {
  const formattedData = useMemo(() => {
    const data = formatGLList({
      list: glTransactions as GeneralLedgerTransaction[],
      currenciesList,
    });

    return data;
  }, [glTransactions, currenciesList]);

  const onRowClick = (id: string) => {
    setGlTransactionSidePanelVisible(true);
    setTransactionSidepanelVisible(false);

    if (onGlTransactionClick) {
      onGlTransactionClick(id);
    }
  };

  let content;

  if (glTransactionsIsLoading) {
    content = (
      <div className={styles.contentLoader}>
        <IconLoader />
      </div>
    );
  } else if (!glTransactionsIsLoading && !glTransactions?.length) {
    content = (
      <div className={styles.accountingEntriesEmpty}>
        There are no accounting entries
      </div>
    );
  } else if (
    !glTransactionsIsLoading &&
    glTransactions &&
    glTransactions.length > 0
  ) {
    content = (
      <div className={styles.accountingEntriesContent}>
        <Table
          filters={{}}
          onFilterChange={() => {}}
          columns={columns}
          data={formattedData || []}
          onRowClick={onRowClick}
          onSort={() => {}}
          sort={{}}
          columnsLabels={{}}
          withScroll
        />
      </div>
    );
  }

  return (
    <div className={styles.accountingEntriesWrapper}>
      <div className={styles.accountingEntriesTop}>
        <div className={styles.accountingEntriesTitle}>Accounting entries</div>
      </div>
      {content}
    </div>
  );
}
